import { getClient, SessionData } from '@chegg/rio-sdk-web'
import { ClientInterface } from '@chegg/rio-sdk-web/dist/types/types'
import { captureError } from '@src/utils/errors'
import { Target } from 'redux-beacon'
import { rioEvent } from './rsw'
import { EventSchemas } from './rsw/eventSchemas'
import { EventWithConfig } from './types'

export const getRioClient = (): ClientInterface<EventSchemas> => getClient<EventSchemas>()
export const initializeWtaClient = (options: SessionData) => getRioClient().init(options)

const rioAnalytics = (): Target => (events: EventWithConfig[]) => {
  if (typeof window === 'undefined') {
    return
  }

  const client = getRioClient()

  events.forEach(event => {
    const { payload, config } = event
    if (typeof payload === 'object') {
      rioEvent(client, payload, config).catch(captureError)
    }
  })
}

export default rioAnalytics



// WEBPACK FOOTER //
// ./src/state/analytics/rioAnalytics.ts